import { useTranslation } from "react-i18next";

import { IObjectionCard } from "../../../../../models/CallQueue";
import { SectionCard } from "../Pill";

// The copy is set per customer in Admin, Call Centre; the API fills in the max and validity.
export default function ObjectionCards({ cards }: { cards: IObjectionCard[] }) {
  const { t } = useTranslation("leads");
  if (cards.length === 0) return null;

  return (
    <SectionCard title={t("If they say…")}>
      <div className="grid grid-cols-1 gap-3 px-4 py-3.5 text-[13px] sm:grid-cols-2 sm:px-5">
        {cards.map((card) => (
          <div key={card.title} className="flex flex-col gap-1 rounded-lg border border-gray-200 px-3 py-2.5">
            <span className="font-semibold text-gray-900">{card.title}</span>
            <span className="text-gray-700">{card.body}</span>
          </div>
        ))}
      </div>
    </SectionCard>
  );
}
